import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  Edit,
  SimpleForm,
  TextInput,
  Create,
  Pagination,
  Filter
} from 'react-admin';

export const CategoryFilter = props => (
  <Filter {...props} variant="outlined">
    <TextInput label="Search" source="q" alwaysOn />
  </Filter>
)

const CategoryListPagination = props => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
)

export const CategoryList = props => (
  <List {...props} filters={<CategoryFilter />} pagination={<CategoryListPagination />} perPage={50} title="Argomenti articoli">
    <Datagrid rowClick="edit">
      {/* <TextField source="id" /> */}
      {/* <DateField source="createdAt" />
      <DateField source="updatedAt" /> */}
      <TextField source="Nome" />
      <TextField source="Name" />
    </Datagrid>
  </List>
);

export const CategoryEdit = props => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="Nome" variant="outlined" />
      <TextInput source="Name" variant="outlined" />
    </SimpleForm>
  </Edit>
);

export const CategoryCreate = props => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="Nome" variant="outlined" />
      <TextInput source="Name" variant="outlined" />
    </SimpleForm>
  </Create>
);

export default {
  list: CategoryList,
  edit: CategoryEdit,
  create: CategoryCreate
}